module.exports = __webpack_public_path__ + "img/bg.04fc6187.jpg";